import { Brand, createBranded } from '@deltasierra/type-utilities';
import { FullAuditable, HasId, AuditableKeys } from '../../../common/model/traits';
import { CurrencyNumber, CurrencyCode } from '../../../common/lang/numbers';
import { Omit } from '../../../common/lang/types';
import { PrintProviderShoppingCartOrderId } from '../../../printProvider/PrintProviderShoppingCartOrder';
import { StripeConfigurationId } from './StripeConfiguration';

export type StripeChargeId = Brand<number, 'StripeChargeId'>;
export const StripeChargeId = createBranded<StripeChargeId>();

export interface StripeCharge extends HasId<StripeChargeId>, FullAuditable {
    amountInCents: CurrencyNumber;
    currency: CurrencyCode;
    source: string;
    status: 'failed' | 'pending' | 'succeeded';
    paymentReference: string | null;
    paymentReceiptUrl: string | null;
    paymentReceiptEmail: string | null;
    applicationFeeReference: string | null;
    applicationFeeAmountInCents: CurrencyNumber | null;
    failureCode: string | null;
    failureStatusCode: number | null;
    failureMessage: string | null;
    stripeConfigurationId: StripeConfigurationId | null;
}

export type StripeChargeDto = Omit<StripeCharge, AuditableKeys>;

export type CreateStripeChargeBody = Pick<
    StripeCharge,
    'amountInCents' | 'currency' | 'source' | 'stripeConfigurationId'
> & {
    description?: string;
    localeCode: string;
    locationMapId?: number;
    printProviderShoppingCartOrderId?: PrintProviderShoppingCartOrderId;
};

export interface StripeChargeErrorResponse {
    charge: string;
    code: string;
    docUrl: string;
    message: string;
    type: string;
    statusCode: number;
    requestId: string;
}
